/**
 * AppShell — каркас интерфейса оператора платформы.
 *
 * Responsive по дизайну v4: 1280+ фиксированный сайдбар 220px, 1024
 * сворачиваемый, 768 icon-rail, 375 burger + bottom-tabbar. В каркасе
 * реализована базовая структура (сайдбар + контент) на CSS-переменных D5b;
 * тонкая адаптация брейкпоинтов — в admin.css.
 */
import type { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { Button } from '@hsc/ui';
import { useAuth } from '@hsc/auth';
import { NAV_ITEMS } from './nav.js';

export interface AppShellProps {
  children: ReactNode;
}

export function AppShell({ children }: AppShellProps): JSX.Element {
  const { logout } = useAuth();
  return (
    <div className="admin-shell">
      <aside className="admin-shell__sidebar" aria-label="Главная навигация">
        <div className="admin-shell__brand">
          <span aria-hidden="true" className="admin-shell__logo">L</span>
          <span className="admin-shell__brand-text">LovArt · Admin</span>
        </div>
        <nav className="admin-shell__nav">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                'admin-shell__nav-link' + (isActive ? ' admin-shell__nav-link--active' : '')
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="admin-shell__footer">
          <Button variant="ghost" size="sm" onClick={() => logout()}>
            Выйти
          </Button>
        </div>
      </aside>
      <main className="admin-shell__content">{children}</main>
    </div>
  );
}
